module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-09.86f88ace.png";